module.exports = __webpack_public_path__ + "static/img/about_hd2x.ba15082.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_hd2x.png
// module id = qP6n
// module chunks = 1